<script>
import { formatMoney } from '../../utilities/helpers';
import {
  mountCard,
  confirmSubscription,
} from './stripe-elements';

export default {
  name: 'PaymentsMixin',
  data() {
    return {
      paymentRequestFailedToMount: false,
    };
  },
  methods: {
    handleErrorMessages(data = {}) {
      let message = '';
      if (data.message) {
        message = data.message;
      } else if (data.error) {
        message = data.error.message;
      } else {
        message = 'error, something went wrong';
      }
      this.displayError = message;
      this.disabled = false;
      this.$emit('emit-global-loading', false);
    },
    disableError(e) {
      this.nameError = e;
      this.displayError = '';
    },
    updateName(event) {
      this.nameOnCard = event;
    },
    formatMoney(amount) {
      return formatMoney(amount);
    },
    async mountCardAndAddSubmitListener() {
      const card = await mountCard('#card-element');
      card.on('change', (event) => {
        this.errorCall(event);
      });
    },
    errorCall(event) {
      event.error ? this.displayError = event.error.message : this.displayError = '';
      event.complete ? this.disabled = false : this.disabled = true;
      this.disabled && event.error ? this.displayError = event.error.message : this.displayError = '';
    },
    getSuccessfulSubscriptionStatus(latestInvoice, confirmation) {
      let subscriptionSetupSuccessful;
      let paymentIntentId;
      const { paymentIntent, setupIntent } = confirmation;
      if (paymentIntent) {
        subscriptionSetupSuccessful = (paymentIntent.status === 'succeeded');
        paymentIntentId = paymentIntent.id;
      } else if (setupIntent) {
        subscriptionSetupSuccessful = (setupIntent.status === 'succeeded');
      } else {
        subscriptionSetupSuccessful = (latestInvoice.status === 'paid');
      }
      return {
        subscriptionSetupSuccessful,
        paymentIntentId,
      };
    },
    async confirmTheSubscriptionAndRedirect(subscriptionId, paymentIntentId = undefined) {
      const { orderId } = this;
      const { data, status } = await confirmSubscription(subscriptionId, paymentIntentId, orderId);
      if (status === true) {
        const { uuid } = data;
        const url = `/order/${uuid}`;
        window.location.href = url;
      } else {
        this.handleErrorMessages(data);
      }
    },
    confirmPaymentHasSucceeded(paymentIntent) {
      return paymentIntent.status === 'succeeded';
    },

  },
  computed: {
    isFacebookApp() {
      const ua = navigator.userAgent
          || navigator.vendor
          || window.opera;
      return (ua.indexOf('FBAN') > -1)
          || (ua.indexOf('FBAV') > -1);
    },
    showFacebookMessage() {
      return this.isFacebookApp && this.paymentRequestFailedToMount;
    },
  },
};
</script>

<style scoped>

</style>
